import { captureEvent } from '@sentry/browser'

export const reportErrorToSentry = (message: string) => {
  captureEvent({
    message,
  })
}
